import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import { useGetReturnRequestLogPayload } from "@babackapp/private-api-client/client/use-get-return-request-log-payload";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";

/**
 * The event body of a Klaviyo / Brevo log, pretty-printed. Recent logs keep it
 * apart (`hasPayload`): it is fetched once the activity is unfolded. Older
 * logs still carry it inline.
 */
export function useEventProperties(
  activity: ReturnRequestLogDto,
  returnRequestId: string,
  isOpen: boolean,
) {
  const params = activity.params as {
    eventProperties?: string;
    hasPayload?: boolean;
  };
  const { data: shop } = useCurrentShopSuspense();
  const { data, isLoading, isError } = useGetReturnRequestLogPayload({
    shopId: shop?.id ?? "",
    returnRequestId,
    logId: activity.id,
    enabled: isOpen && !!params.hasPayload && !!shop?.id,
  });
  const raw = params.hasPayload
    ? (data?.payload.eventProperties as string | undefined)
    : params.eventProperties;

  return { eventProperties: format(raw), isLoading, isError };
}

function format(eventProperties: string | undefined) {
  if (eventProperties === undefined) return undefined;
  try {
    return JSON.stringify(JSON.parse(eventProperties), null, 2);
  } catch {
    return eventProperties;
  }
}
